import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWorkTimes } from "../../../services/worktimes";
import { addDays } from "date-fns";

const initialState = {
  screenType: 0,
  selectedDate: null,
  selectedUser: null,
};

export const fetchActivityData = createAsyncThunk(
  "activities/fetchActivityData",
  async (_, thunkApi) => {
    try {
      const { filters } = thunkApi.getState();
      const organizationId = JSON.parse(localStorage.getItem("organizationID"));

      const fetchedData = await getWorkTimes(
        organizationId,
        filters.filterParams
      );

      return fetchedData;
    } catch (error) {
      console.log("error - ", error);
    }
  }
);

export const activitiesSlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    setScreenType: (state, action) => {
      state.screenType = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchActivityData.pending, (state, action) => {
      state.isLoading = true;
      state.activityData = [];
    });

    builder.addCase(fetchActivityData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.activityData = action.payload.data;
    });

    builder.addCase(fetchActivityData.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const { setScreenType, setSelectedDate, setSelectedUser } = activitiesSlice.actions;

export default activitiesSlice.reducer;
